//  React TS Base Styles
import colors from '../../base/colors'
import borders from '../../base/borders'
import typography from '../../base/typography'

//  React TS Helper Functions
import pxToRem from '../../functions/pxToRem'

const { light, text, gray } = colors
const { borderRadius } = borders
const { size } = typography

// types
type Types = any

const menuItem: Types = {
  styleOverrides: {
    root: {
      minWidth: pxToRem(160),
      minHeight: 'unset',
      padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      color: text.main,
      transition: 'background-color 300ms ease, color 300ms ease',

      '&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus':
        {
          backgroundColor: light.main,
          color: gray[0],
        },
    },
  },
}

export default menuItem
